import { render, staticRenderFns } from "./CrudSideMenu.vue?vue&type=template&id=46bc4be5&scoped=true"
import script from "./CrudSideMenu.vue?vue&type=script&lang=js"
export * from "./CrudSideMenu.vue?vue&type=script&lang=js"
import style0 from "./CrudSideMenu.vue?vue&type=style&index=0&id=46bc4be5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bc4be5",
  null
  
)

export default component.exports